import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../api/client';

const HEARTBEAT_INTERVAL_MS = 60_000;
const SKIP_PREFIXES = ['/login', '/register', '/invite', '/privacy', '/consent', '/oferta'];

function shouldSendHeartbeat(user, pathname) {
  if (!user) return false;
  if (user.is_staff || user.is_admin || user.is_teacher) return false;
  const path = pathname || '/';
  if (SKIP_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`))) return false;
  return true;
}

/**
 * Лёгкий ping активности для админки: раз в 60 с при видимой вкладке + при смене маршрута.
 */
export default function useVisitHeartbeat(user) {
  const location = useLocation();
  const lastSentPath = useRef('');

  useEffect(() => {
    if (!shouldSendHeartbeat(user, location.pathname)) return undefined;

    const send = () => {
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
        return;
      }
      const path = location.pathname || '/';
      lastSentPath.current = path;
      api.post('/auth/heartbeat/', { path }).catch(() => {});
    };

    // смена маршрута — сразу (сервер отрежет чаще 20 с)
    send();

    const intervalId = window.setInterval(() => {
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
        return;
      }
      send();
    }, HEARTBEAT_INTERVAL_MS);

    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        send();
      }
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      window.clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [user, location.pathname]);
}
